export const GET_PRICEOM_WEB_JOBS_REQUEST = 'GET_PRICEOM_WEB_JOBS_REQUEST';
export const GET_PRICEOM_WEB_JOBS_REQUEST_SUCCESS = 'GET_PRICEOM_WEB_JOBS_REQUEST_SUCCESS';
export const GET_PRICEOM_WEB_JOBS_REQUEST_FAILURE = 'GET_PRICEOM_WEB_JOBS_REQUEST_FAILURE';
export const SET_PRICEOM_FILTER_WEB_JOBS = 'SET_PRICEOM_FILTER_WEB_JOBS';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic/redux/constants/web_jobs.constants.js